<template lang="pug">
app-page(:singleView="true")
  v-card(height="100%" slot="content")
    v-card-title
      v-dialog(v-model="dialog" max-width="900px" persistent)
        v-card
          v-card-title
            span.headline {{ editedItem.key }}
          v-card-text
            v-container(grid-list-md)
              v-layout(wrap)
                v-flex(xs12)
                  v-select(
                    v-if="editedItem.tags.includes('Variable') && \
                      !editedItem.possibleValues"
                    :items="['Yes', 'No']"
                    :label="editedItem.placeholder"
                    v-model="editedItem.md"
                  )
                  v-select(
                    v-if="editedItem.tags.includes('Variable') && \
                      editedItem.possibleValues"
                    :items="editedItem.possibleValues"
                    :label="editedItem.placeholder"
                    v-model="editedItem.md"
                  )
                  c-e-content-editor-quill(
                    v-if="!editedItem.tags.includes('Variable')"
                    :content="editedItem.html"
                    v-on:onUpdate="applyTextEdit"
                  )
          v-checkbox(
            v-model="editedItem.groupLocked"
            label="Group Locked"
            style='margin-left: 16px'
            v-if="isGroupAdmin()"
          )
          v-card-actions
            v-spacer
            v-btn(color="blue darken-1" flat @click.native="close") Cancel
            v-btn(color="blue darken-1" flat @click.native="save") Save
      v-checkbox(
        v-if="siteType > 1"
        v-model="groupLockedFilter"
        label="Only show group locked"
        style='margin-top: 0px; margin-bottom: -50px; padding-top: 0px'
      )
      v-spacer
      v-text-field(
        append-icon="search"
        label="Search"
        single-line
        hide-details
        v-model="search"
      )
    v-data-table(
      :headers="headers"
      :items="enrichedItems"
      :search="search"
      hide-actions
    )
      template(slot="items" slot-scope="props")
        td {{ props.item.key }}
        td
          v-chip(v-for="tag in props.item.tags" :key="tag" @click.native="chipsearch(tag)")
            strong {{ tag }}
        td(v-html="mdToHtml(props.item.value)").text-xs-left
        td(style="display: flex; align-items: center")
          v-icon(
            v-if="hasAccess('singlecontexteditTable') && !isGroupLocked(props.item)"
            small
            class="mr-2"
            @click="editItem(props.item)"
          ) edit
          v-tooltip(top
            v-if="hasAccess('singlecontexteditTable') && isGroupLocked(props.item)"
          )
            template(
              autoresize
              slot="activator"
            )
              v-icon(
                  small
                  class="mr-2"
                ) edit
            span This value is managed by your group administrator
          v-icon(
            small
            class="mr-2"
            v-if="showGroupLocked(props.item)"
          ) lock
        td {{ props.item.status }}
      template(slot="no-data")
        p There are no context items.
</template>

<script>
import TurndownService from 'turndown';
import { mapGetters, mapState } from 'vuex';
import Base from '@/components/views/Base';
import CEContentEditorQuill from '@/components/content/CEContentEditorQuill';
import intersection from 'lodash/intersection';

const md = require('markdown-it')({
    html: true
});

const COMPLISPACE_ADMIN_ROLE_ID = 4;
const GROUP_ADMIN_ROLE_ID = 3;

export default {
    name: 'Context',

    extends: Base,

    components: {
        CEContentEditorQuill
    },

    data() {
        return {
            headers: [
                {
                    text: 'Key',
                    align: 'left',
                    value: 'key',
                    sortable: true
                },
                {
                    text: 'Tags',
                    align: 'left',
                    value: 'tags',
                    sortable: false
                },
                {
                    text: 'Value',
                    align: 'left',
                    value: 'html',
                    sortable: false
                },
                {
                    text: 'Actions',
                    value: 'name',
                    sortable: false
                },
                {
                    text: 'Status',
                    value: 'status',
                    sortable: true
                }
            ],
            groupLockedFilter: false,
            search: '',
            dialog: false,
            editedItem: {
                key: '',
                md: '',
                html: '',
                tags: [],
                placeholder: '',
                possibleValues: [],
                groupLocked: false
            },
            defaultItem: {
                key: '',
                md: '',
                html: '',
                tags: [],
                placeholder: '',
                possibleValues: []
            }
        };
    },

    created() {
        this.setViewTitle(this.$t('context.title'));
    },

    computed: {
        ...mapState({
            client: state => state.client,
            role: state => state.session.role,
            siteType: state => state.session.siteType
        }),

        ...mapGetters({
            contextItems: 'clientContext/items',
            hasAccess: 'session/hasAccess'
        }),

        enrichedItems() {
            let result = this.contextItems.map((c) => {
                const d = c;
                d.status = d.value ? 'complete' : 'blank';
                return d;
            });

            const roleId = parseInt(this.role, 10);
            const isComplispaceAdmin = roleId === COMPLISPACE_ADMIN_ROLE_ID;

            if (!isComplispaceAdmin) {
                result = result.filter((item) => {
                    const newItemTags = item.tags.map(tag => tag.toLowerCase());
                    return intersection(newItemTags, ['global', 'variable']).length !== 2;
                });
            }

            if (this.groupLockedFilter) {
                return result.filter(item => item.ownerId != null);
            }
            return result;
        }
    },

    methods: {
        isGroupAdmin() {
            const roleId = parseInt(this.role, 10);
            if ((roleId === GROUP_ADMIN_ROLE_ID || roleId === COMPLISPACE_ADMIN_ROLE_ID) &&
                this.siteType === 3 &&
                (this.editedItem.tags.includes('Variable') ||
                this.editedItem.tags.includes('Merge Field'))
            ) {
                return true;
            }
            return false;
        },

        isGroupLocked(item) {
            function groupLockedByChild(client, ownerId) {
                if (client.children && client.children.length > 0) {
                    return client.children.findIndex((child) => {
                        return child.id === ownerId;
                    }) > -1;
                }
                return false;
            }

            if (item.ownerId) {
                if (this.client && (this.client.id === item.ownerId ||
                    groupLockedByChild(this.client, item.ownerId))) {
                    return false;
                }
                return true;
            }
            return false;
        },

        showGroupLocked(item) {
            if (item.ownerId) {
                return true;
            }
            return false;
        },

        chipsearch(tag) {
            this.search = tag;
        },
        editItem(item) {
            this.editedItem.key = item.key;
            this.editedItem.html = item.valueHtml && item.valueHtml !== '' ? item.valueHtml : this.mdToHtml(item.value);
            this.editedItem.md = item.value;

            // NOTE: quickfix for inconsistent storage (casing) of Yes/No possible values
            // TODO: Store data everywhere in a consistent way
            if (this.editedItem.md === 'yes') this.editedItem.md = 'Yes';
            if (this.editedItem.md === 'no') this.editedItem.md = 'No';

            this.editedItem.tags = item.tags;
            this.editedItem.placeholder = item.placeholder ?
                item.placeholder : 'Value';
            this.editedItem.possibleValues = item.possibleValues;
            this.editedItem.groupLocked = !!item.ownerId;
            this.dialog = true;
        },

        close() {
            this.dialog = false;
            setTimeout(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
            }, 300);
        },

        applyTextEdit(content) {
            this.editedItem.output = content;
        },

        mdToHtml(content) {
            if (!content) return null;
            return md.render(content);
        },

        htmlToMd(content) {
            if (!content) return null;
            return content;
        },

        async save() {
            if (this.loading) return;
            this.setLoading(true);

            try {
                let value = null;
                let valueHtml = '';
                if (this.editedItem.tags.includes('Variable')) {
                    value = this.editedItem.md ? this.editedItem.md : '';
                } else {
                    const turndownService = new TurndownService();
                    // No strikethrough or underline in markdown
                    // use html tags instead.
                    turndownService.keep(['s', 'u']);

                    // handle quill editor li element, convert it to md format manually
                    turndownService.addRule('nestedList', {
                        filter: ['li'],
                        replacement(text, content) {
                            const className = content.getAttribute('class');
                            if (className) {
                                const classNameValue = className.match(/ql-indent-[0-9]*/);
                                const number = classNameValue[0].match(/\d+/g)[0];
                                const loopNumber = parseInt(number, 10);
                                if (loopNumber > 0) {
                                    const mdLISpace = new Array(loopNumber + 2).join('  ');
                                    return `\n ${mdLISpace} * ${text}`;
                                }
                            }
                            return `\n * ${text}`;
                        }
                    });
                    value = this.editedItem.output && this.editedItem.output.length > 0
                        ? turndownService.turndown(this.editedItem.output)
                        : '';
                    valueHtml = this.editedItem.output && this.editedItem.output.length > 0
                        ? this.editedItem.output
                        : '';
                }

                // NOTE: have to explicity set details object to strip any
                // Vue observer objects.
                const details = {
                    key: this.editedItem.key,
                    value,
                    groupLocked: this.editedItem.groupLocked,
                    valueHtml
                };
                await this.$store.dispatch(
                    'clientContext/updateContextItem',
                    details
                );
            } catch (error) {
                this.showErrorAlert(error.message);
            } finally {
                this.setLoading(false);
                this.close();
            }
        }
    }
};
</script>

<style scoped>
.theme--light.v-chip {
  background: #EFF3F6;
}
</style>



// WEBPACK FOOTER //
// src/components/views/preferences/Context.vue